import { ActionTree } from 'vuex/types/index'
import { RootState } from '~/store/store.types'
import { SohoModel } from '~/constants/SohoModel'
import { setIncludedResources } from '~/utils/store'
import { RequestParameters } from '~/utils/SohoApi/SohoApi'
import { Product, ProductsState, ProductResource, ProductsFilter } from './products.types'

const actions: ActionTree<ProductsState, RootState> = {
  async fetchProducts ({ commit }, params: RequestParameters<Product, ProductsFilter> = {}) {
    const { data, included } = await this.$sohoApi.get<ProductResource>(SohoModel.Product, { include: 'venue', ...params })

    if (included) {
      setIncludedResources(included, commit)
    }

    commit('SET_PRODUCTS', data)

    return data
  }
}

export default actions
